import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Company, ConnectionService } from '../../services/Connection/connection.service';
import { Cliente } from '../../Interfaces/customer';
import { ScrollService } from '../../services/Scroll/scroll.service';

@Component({
  selector: 'app-rules-cashback',
  templateUrl: './rules-cashback.component.html',
  styleUrl: './rules-cashback.component.css'
})
export class RulesCashbackComponent implements OnInit, AfterViewInit{
  @ViewChild('offCanva') offCanva!: ElementRef
  @Input() company!: Company;
  @Output() closeCanvas : EventEmitter<boolean> = new EventEmitter<boolean>();
  openInfo: boolean = false;
  user!: Cliente;
  offCanvasHeight: string | number = 'auto';
  initHeight: number = 0;
  readonly TIMEOUT_DELAY = 500;
  private startY = 0;
  private isDragging = false;

  constructor(private scrollService: ScrollService){}


  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.openCanva();
    }, this.TIMEOUT_DELAY);

  }

  //Abre o offcanva
  openCanva(){
    this.offCanvasHeight = this.offCanva.nativeElement.offsetHeight;
    this.initHeight = Number(this.offCanvasHeight)
    this.scrollService.disableScroll();
    this.openInfo = true;
  }

  //Quando o usuario clica
  onTouchStart(event: TouchEvent) {
    this.startY = event.touches[0].clientY;
    this.isDragging = true;
  }

  // Quando o usuario arrasta
  onTouchMove(event: TouchEvent) {
    if (!this.isDragging) return;

    const currentY = event.touches[0].clientY;
    const deltaY = currentY - this.startY;

    if (deltaY > 0) {
      this.offCanvasHeight = Math.max(0, this.initHeight - deltaY);
    }
  }

  // Finalizar o toque
  onTouchEnd() {
    this.isDragging = false;

    // Fechar se a altura for pequena
    if (Number(this.offCanvasHeight) < 50) {
      this.closeOffCanvas();
    } else {
      this.offCanvasHeight = this.initHeight; // Resetar altura
    }
  }

  // Fechar o OffCanvas
  closeOffCanvas() {
    this.openInfo = false;
    this.offCanvasHeight = this.initHeight;
    this.closeCanvas.emit(false);

    setTimeout(() => {
      this.scrollService.enableScroll();
    }, this.TIMEOUT_DELAY);
  }
}
